/**
 * TBM 입장 링크(유니버셜 링크/앱 링크) 수신
 * - 일반 카메라로 QR을 스캔했을 때 앱이 설치돼 있으면 OS가 앱을 열고 appUrlOpen으로 URL을 넘김
 * - 입장 토큰만 보관해 두고 홈에서 기존 회원 참석(saveTbmNewU2)을 이어서 처리
 *   (로그아웃 상태면 로그인 후 홈에 도달했을 때 처리)
 */
const PENDING_KEY = 'pendingTbmJoinToken';
export const TBM_JOIN_PENDING_EVENT = 'tbm-join-pending';

// iOS는 링크로 앱이 처음 켜질 때 같은 URL을 launchUrl·appUrlOpen 양쪽으로 줄 수 있어 중복 처리를 막음
const DUPLICATE_WINDOW_MS = 5000;
let lastJoin = { token: '', at: 0 };

/** @returns {boolean} 새로 보관했으면 true, 직전과 같은 링크라 무시했으면 false */
export const SetPendingTbmJoinToken = (token) => {
  const now = Date.now();
  if (token === lastJoin.token && now - lastJoin.at < DUPLICATE_WINDOW_MS) {
    return false;
  }
  lastJoin = { token, at: now };
  try {
    sessionStorage.setItem(PENDING_KEY, token);
  } catch (e) {
    console.error(e);
  }
  window.dispatchEvent(new Event(TBM_JOIN_PENDING_EVENT));
  return true;
};

/** 보관된 토큰을 꺼내고 지움 (없으면 '') */
export const TakePendingTbmJoinToken = () => {
  try {
    const token = sessionStorage.getItem(PENDING_KEY) || '';
    if (token) sessionStorage.removeItem(PENDING_KEY);
    return token;
  } catch (e) {
    return '';
  }
};
